export const applyNoWrap = (inputString: string, words: Array<string>) => {
  let outputString = inputString;
  words.forEach(word => {
    const wordWithNbsp = word.replace(/ /g, '\u00A0');
    const regex = new RegExp(`\\b${word}\\b`, 'g');
    outputString = outputString?.replace(regex, `${wordWithNbsp}`);
  });
  return outputString;
};
